import { cohttp } from "./cohttp/client.mjs";
export const ocaml = {
    info: {
        key: 'ocaml',
        title: 'OCaml',
        extname: '.ml',
        default: 'cohttp',
    },
    clientsById: {
        cohttp,
    },
};
